import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { Venue_Entity } from "../../entities/venue";
import { Ids } from "../../reducers/rhapsody";

const venuesAdapter = createEntityAdapter<Venue_Entity>();
const initialState = venuesAdapter.getInitialState();

export const venueEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getVenues: build.query<EntityState<Venue_Entity>, void>({
      query: () => `venues`,
      transformResponse: (responseData: Venue_Entity[]) => {
        return venuesAdapter.setAll(initialState, responseData);
      },
      providesTags: ["venues"],
    }),
    getVenue: build.query<Venue_Entity, Ids>({
      query: (arg) => {
        return {
          url: `venues/${arg.id}`,
          params: {
            sourceID: arg.sourceID,
            sourceRecordID: arg.sourceRecordID,
          },
        };
      },
      providesTags: ["venues"],
    }),
    createVenue: build.mutation<Venue_Entity, Partial<Venue_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `venues`,
      }),
      invalidatesTags: ["venues"],
    }),
    updateVenue: build.mutation<
      void,
      { id: number; body: Partial<Venue_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `venues/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "venues", id },
        "venues",
      ],
    }),
    deleteVenue: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `venues/${id}`,
      }),
      invalidatesTags: ["venues"],
    }),
  }),
});

export const {
  useGetVenueQuery,
  useLazyGetVenuesQuery,
  useGetVenuesQuery,
  useCreateVenueMutation,
  useDeleteVenueMutation,
  useUpdateVenueMutation,
} = venueEndpoints;

export default venueEndpoints;
